import StylesWrapper from './StylesWrapper';

export default StylesWrapper;
